/* eslint-disable import/no-unresolved */
import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';
import { SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';

import Carousel from '../../../../Core/Carousel';
import FeatureCards from '../../../Cards/FeatureCards';
import RichText from '../../../../Core/RichText';

import { StyledContainer, Heading } from './styles';

const CardMobileCarousel = ({ data }) => {
  if (!data) return null;

  const { id, elements, heading, headingAlignment } = data;

  const blogHeader = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => (
        <Heading headingAlignment={headingAlignment}>{children}</Heading>
      ),
      [BLOCKS.HEADING_1]: (_, children) => (
        <Heading headingAlignment={headingAlignment}>{children}</Heading>
      ),
      [BLOCKS.HEADING_2]: (_, children) => (
        <Heading headingAlignment={headingAlignment}>{children}</Heading>
      ),
      [BLOCKS.HEADING_3]: (_, children) => (
        <Heading headingAlignment={headingAlignment}>{children}</Heading>
      ),
    },
  };

  const breakpoints = {
    200: {
      slidesPerView: '1.25',
      spaceBetween: 24,
    },
    320: {
      slidesPerView: '1.25',
      spaceBetween: 24,
    },
    600: {
      slidesPerView: '2.25',
      spaceBetween: 24,
    },
    768: {
      slidesPerView: '2.25',
      spaceBetween: 24,
    },
  };

  return (
    <StyledContainer>
      <RichText document={heading} options={blogHeader} />
      <Carousel
        id={id}
        breakpoints={breakpoints}
        modules={[Pagination]}
        pagination={{ clickable: true }}
      >
        {elements.map(card => {
          return (
            <SwiperSlide key={card.id}>
              <FeatureCards data={card} />
            </SwiperSlide>
          );
        })}
      </Carousel>
    </StyledContainer>
  );
};

CardMobileCarousel.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default CardMobileCarousel;
